import React, { Component } from 'react'
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import Drawer from 'react-drag-drawer';
import '../Popupstyle.css';
import { it } from 'date-fns/locale'
import ThemeManager from '../ThemeManager';
import i18n from "i18next";

export class BirthDate extends Component {

    constructor(props){
        super(props);

        let themeManager = ThemeManager.getInstance();
        var _secondaryTextColor = themeManager.getSecondaryTextColor();

        this.state = { userInfo: props.user,
                        date: new Date("2009-12-31"),
                        openConfirm: false,
                        openConfirmChange: false,
                      birthDateString: '-',
                    isProcessing: false, 
                    day: '0', 
                    month: '0', 
                    year: '0', 
                    error: false,
                    dayColor: _secondaryTextColor,
                    monthColor: _secondaryTextColor,
                    yearColor: _secondaryTextColor};
       
    }//ar date = new Date("2016-01-04 10:34:23");

    toggle = () => {
      this.setState({ openConfirm: false, openConfirmChange: false })
   }

   onConfirmSet = (date) => {

    var textualDate = new Intl.DateTimeFormat("it-IT", {
      year: "numeric",
        month: "long",
        day: "2-digit"
    }).format(date);


      this.setState({ date: date, birthDateString: textualDate, openConfirm: true });
  }

  changeYear = (e) => {
    let themeManager = ThemeManager.getInstance();
    var _mainTextColor = themeManager.getMainTextColor();
    var _secondaryTextColor = themeManager.getSecondaryTextColor();

    var newValue = e.target.value;
    var colorValue = _mainTextColor;
    if(newValue==="0"){
      colorValue = _secondaryTextColor;
    }
    this.setState( { year: newValue, error: false, yearColor: colorValue });

  }

  changeMonth = (e) => {
    let themeManager = ThemeManager.getInstance();
    var _mainTextColor = themeManager.getMainTextColor();
    var _secondaryTextColor = themeManager.getSecondaryTextColor();

    var newValue = e.target.value;
    var colorValue = _mainTextColor;
    if(newValue==="0"){
      colorValue = _secondaryTextColor;
    }
    this.setState( { month: newValue, error: false, monthColor: colorValue  });

  }

  changeDay = (e) => {
    let themeManager = ThemeManager.getInstance();
    var _mainTextColor = themeManager.getMainTextColor();
    var _secondaryTextColor = themeManager.getSecondaryTextColor();

    var newValue = e.target.value;
    var colorValue = _mainTextColor;
    if(newValue==="0"){
      colorValue = _secondaryTextColor;
    }
    this.setState( { day: newValue, error: false, dayColor: colorValue });

  }

  confimDate = (e) => {
    
    if(this.state.day>0 && this.state.day<32 && this.state.month>0 && this.state.month<13 && this.state.year>1900 && this.state.year<2011){
      var datestring = this.state.year+'/'+this.state.month+'/'+this.state.day;
      var date = new Date(datestring);
      this.onConfirmSet(date);
    }else{
      this.setState({  error: true})
    }
    
  }

    confirmChange = (e) => {
      this.setState({ openConfirmChange: true});
    }

    changeDate = (e) => {

      if(!this.setState.isProcessing){

        this.setState({ isProcessing: true});
        var date = '0000-00-00';
        var sessiontoken = localStorage.getItem('session_token');
        if(sessiontoken === null){
          sessiontoken = '';
        }
    
        const requestOptions = {
          method: 'POST',
          headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded',
          }),
          body: JSON.stringify({
                    date: date,
                    token: sessiontoken
                  })
          };
        
              const apiUrl = 'https://getfy-business.com/user/v8/user/set/birth';
    
        fetch(apiUrl, requestOptions)
        .then(r => r.json())
        .then(r => { 
            window.location.reload();
        }).catch(e => {
            window.location.reload();
        });
      }
    }

    confirm = (e) => {
      if(!this.setState.isProcessing){
       
        this.setState({ isProcessing: true});

        var date = new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          }).format(this.state.date);
          
        var sessiontoken = localStorage.getItem('session_token');
        if(sessiontoken === null){
          sessiontoken = '';
        }
    
        const requestOptions = {
          method: 'POST',
          headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded',
          }),
          body: JSON.stringify({
                    date: date,
                    token: sessiontoken
                  })
          };
        
              const apiUrl = 'https://getfy-business.com/user/v8/user/set/birth';
    
        fetch(apiUrl, requestOptions)
        .then(r => r.json())
        .then(r => { 
            window.location.reload();
        }).catch(e => {
            window.location.reload();
        });

      }
    }

    render() {


      let themeManager = ThemeManager.getInstance();
        const _backgroundColor = themeManager.getBackgroundColor();
        const _selectionColor = themeManager.getSelectionColor();
        const _mainTextColor = themeManager.getMainTextColor();
        const _secondaryTextColor = themeManager.getSecondaryTextColor();
        const _buttonTextColor = themeManager.getButtonTextColor();
        const _itemBackgroundColor = themeManager.getItemBackgroundColor();
        const _errorColor = themeManager.getErrorColor();

      const days = [];
      for(var i=1; i<32; i++){
        days.push(i);
      }

      const years = [];
      for(var i=2010; i>1909; i--){
        years.push(i);
      }


        return (
            <div>

            { this.state.userInfo.birth === 'need' &&
              <div>
              <div style={{marginTop: '40px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: _secondaryTextColor, fontSize: '12px'}}>
              {i18n.t('insert.your')}<p style={{ color: _selectionColor, marginLeft: '8px', marginRight: '8px', fontSize: '14px', fontWeight: 'bold'}}>{i18n.t('birth.date')}</p>
            </div>
                
            <select className="nosafari" style={{ marginTop: '20px', width: '250px', height: '45px', backgroundColor: _itemBackgroundColor,
             color: this.state.dayColor, border: '0px solid', borderRadius: '8px', fontWeight: 'normal'
             }} value={this.state.day} onChange={this.changeDay}>
            <option value="0">{i18n.t('birth.day')}</option>
            { days.map((day, i) =>
                <option key={i} value={day}>{day}</option>
                )
            }
            
            </select>
            <br />
            <select className="nosafari" style={{ marginTop: '15px', width: '250px', height: '45px', backgroundColor: _itemBackgroundColor,
             color: this.state.monthColor, border: '0px solid', borderRadius: '8px', fontWeight: 'normal'
             }} value={this.state.month} onChange={this.changeMonth}>
            <option value="0">{i18n.t('birth.month')}</option>
            <option value="1">{i18n.t('jan')}</option>
            <option value="2">{i18n.t('feb')}</option>
            <option value="3">{i18n.t('mar')}</option>
            <option value="4">{i18n.t('apr')}</option>
            <option value="5">{i18n.t('may')}</option>
            <option value="6">{i18n.t('jun')}</option>
            <option value="7">{i18n.t('jul')}</option>
            <option value="8">{i18n.t('aug')}</option>
            <option value="9">{i18n.t('sep')}</option>
            <option value="10">{i18n.t('oct')}</option>
            <option value="11">{i18n.t('nov')}</option>
            <option value="12">{i18n.t('dec')}</option>
            </select>
            <br />
            <select className="nosafari" style={{ marginTop: '15px', width: '250px', height: '45px', backgroundColor: _itemBackgroundColor,
             color: this.state.yearColor, border: '0px solid', borderRadius: '8px', fontWeight: 'normal'
             }} value={this.state.state} onChange={this.changeYear}>
            <option value="0">{i18n.t('birth.year')}</option>
            { years.map((year, i) =>
                <option key={i} value={year}>{year}</option>
                )
            }
            
            </select>


                <div  style={{marginTop: '25px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <p style={{ cursor: 'pointer',  fontWeight: 'bold', height: '45px', width: '250px', borderRadius: '8px', backgroundColor: _selectionColor, fontSize: '14px', 
            textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: _buttonTextColor }}
            onClick={this.confimDate}
            >
                    {i18n.t('confirm')}</p>
                    </div>
                    </div>
            }

{ this.state.error && <p style={{ marginTop: '30px', color: _errorColor, fontSize: '12px', fontWeight: 'bold'}}>{i18n.t('insert.birth.date')}</p> }
          { this.state.userInfo.birth !== 'need' &&
              <div>
             
            <div  style={{marginTop: '80px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                      <div>
                    <div onClick={this.confirmCancel} style={{marginTop: '20px', fontSize: '15px', color: _mainTextColor }}>{i18n.t('need.birth.date')}</div>
                    <div onClick={this.confirmCancel} style={{marginTop: '-12px', fontSize: '15px', color: _mainTextColor, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    {i18n.t('at.least')} <p style={{ marginLeft: '10px', marginRight: '10px', fontWeight: 'bold', color: _selectionColor }}>{this.state.userInfo.birth}</p>{i18n.t('years')}
                      </div>
                    </div>
                    </div>
          
            
                <div  style={{marginTop: '25px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <p style={{ cursor: 'pointer',  fontWeight: 'bold', height: '45px', width: '250px', borderRadius: '8px', backgroundColor: _selectionColor, fontSize: '14px', 
            textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: _buttonTextColor }}
            onClick={this.confirmChange}
            >
                    {i18n.t('change')}</p>
                    </div>
                    </div>
            }


                    <br />
                    <br />
                    <br />

                    <Drawer
                    open={this.state.openConfirm}
                        onRequestClose={this.toggle}
                        modalElementClass="modal">
                            <div>
                    <div  style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                      <div>
                    <div style={{marginTop: '20px', fontSize: '14px', color: 'rgb(60,60,60)' }}>{i18n.t('confirm.birth.date')}</div>
                    <div style={{marginTop: '-12px', fontSize: '14px', color: 'rgb(60,60,60)', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                      <p style={{ fontWeight: 'bold'}}>{this.state.birthDateString}</p>?
                      </div>
                    </div>
                    </div>
                    <div  style={{marginTop: '15px',  textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <p style={{ cursor: 'pointer',  fontWeight: 'bold', height: '40px', width: '250px', borderRadius: '8px', backgroundColor: _selectionColor, fontSize: '14px', 
            textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: _buttonTextColor }}
            onClick={this.confirm}
            >{i18n.t('confirm')}</p>
                    </div>
                    <div  style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <div onClick={this.toggle} style={{cursor: 'pointer', fontSize: '14px', color: 'rgb(60,60,60)' }}>{i18n.t('cancel')}</div>
                    </div>
                    </div>
                    </Drawer>


                    <Drawer
                    open={this.state.openConfirmChange}
                        onRequestClose={this.toggle}
                        modalElementClass="modal">
                            <div>
                    <div  style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                      
                    <div style={{marginTop: '20px', fontSize: '14px', color: 'rgb(60,60,60)' }}>
                    {i18n.t('change.birth.date')}<br />{i18n.t('alert.birth.date')}</div>                   
                    </div>
                    <div  style={{marginTop: '10px',  textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <p style={{ cursor: 'pointer',  fontWeight: 'bold', height: '40px', width: '250px', borderRadius: '8px', backgroundColor: _selectionColor, fontSize: '14px', 
            textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: _buttonTextColor}}
            onClick={this.changeDate}
            >{i18n.t('change')}</p>
                    </div>
                    <div  style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <div onClick={this.toggle} style={{cursor: 'pointer', fontSize: '14px', color: 'rgb(60,60,60)' }}>{i18n.t('cancel')}</div>
                    </div>
                    </div>
                    </Drawer>
              
            </div>
        )
    }
}

export default BirthDate
